// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PendingCircleIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true",
  "data-icon": "PendingCircle/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.998 1.6a6.4 6.4 0 1 1 0 12.8 6.4 6.4 0 0 1 0-12.8Zm1.45 6.971a.571.571 0 0 0 0 1.143h.836a2.859 2.859 0 0 1-4.98-.762.572.572 0 0 0-1.078.381 4.002 4.002 0 0 0 6.63 1.466v.323a.572.572 0 1 0 1.142 0v-1.98a.571.571 0 0 0-.571-.57h-1.98ZM7.997 4c-1.12 0-2.132.46-2.857 1.201v-.323a.572.572 0 1 0-1.143 0v1.98c0 .315.256.57.571.57h1.98a.571.571 0 0 0 0-1.142h-.837a2.859 2.859 0 0 1 4.98.762.572.572 0 0 0 1.079-.381A4.002 4.002 0 0 0 7.998 4Z"
}));
export default PendingCircleIcon;
